import type { FaireProductEntity } from "../../entity_types/product";

export const p_44ztauwxab: FaireProductEntity = {
  token: "p_44ztauwxab",
  type: "product",
  name: "Colombia Supremo Washed Whole Bean Coffee",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/bddece65718f6bff77703590fcb580f811843028677cdde6e23c9d1115695ee6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f23a60e920baba69400bee1452e77b494f20b0d70aad678c4162a761b8175e0f.jpeg",
    "https://cdn.faire.com/fastly/a670684572bcab758d9421a81f91770e551afeb85fcb506d020b2b0b8464b5e6.jpeg"
  ],
  priceDollars: 14,
  description: "** Currently Shipping in Off-White Tins\n\nSize: 10oz Retail Tin, 2lb Bags, 5lb Bags\nTaste Notes: Orange, Molasses, Sage\nCountry: Colombia\nLocation: Hulia\nElevation: 1500 MASL\nVariety: Caturra\nProcessing: Fully Washed\n\nAn easy drinking drip coffee! This coffee is cultivated on farms that average about 2.5 hectares in size. Producers pick and process coffee at their own micro-wet mills and then dry their own coffee, typically on elevated tables inside solar dryers that provide protection from the nearly continuous rainy season. We have found that this coffee sings best on drip and manual brew.",
  tags: [],
  msrpDollars: 20.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:34.185Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
